// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountUpdateContactPreferencesDefaultResponse {
    static getAttributeTypeMap() {
        return AccountUpdateContactPreferencesDefaultResponse.attributeTypeMap;
    }
}
AccountUpdateContactPreferencesDefaultResponse.discriminator = undefined;
AccountUpdateContactPreferencesDefaultResponse.additionalProperties = false;
AccountUpdateContactPreferencesDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IUpdateContactPreferencesResultModel"
    },
];
//# sourceMappingURL=accountUpdateContactPreferencesDefaultResponse.js.map